/* eslint-disable prefer-const */
/* eslint-disable import/prefer-default-export */
import { createBrowserHistory } from 'history';

export let history = createBrowserHistory();
